<template>
  <v-container fluid class="chat-app-container" v-if="$vuetify.breakpoint.mdAndUp">
    <div class="chat-layout">
      <chat-menu-section v-if="profile.type === 'Agency' || profile.type === 'Volunteer'" />
      <div class="chat-main-area" v-if="profile.type === 'Agency' || profile.type === 'Volunteer'">
        <router-view />
      </div>
      <not-found v-else />
    </div>
  </v-container>
  <v-container fluid class="mobile-chat-container" v-else>
    <router-view />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import ChatMenuSection from "./ChatMenuSection.vue";
import NotFound from "../NotFound.vue";

export default {
  components: {
    ChatMenuSection,
    NotFound
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      snackbar: false
    };
  },
  methods: {
    checkApproved() {
      if (!this.profile) return;
      
      if (this.profile.status === "Pending" || this.profile.status === "Rejected") {
        if (this.$route.name !== "agency-approval") {
          this.$router.push({ name: "agency-approval" });
        }
      } else if (this.profile.status === "Available") {
        if (this.$route.name !== "chat" && this.$route.name !== "chat-details") {
          this.$router.push({ name: "chat" });
        }
      }
    },
    requestNotificationPermission() {
      if ("Notification" in window && Notification.permission !== "granted") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            console.log("Notification permission granted.");
          }
        });
      }
    }
  },
  computed: {
    ...mapState("auth", {
      profile: "profile",
      profileType: "type"
    })
  },
  watch: {
    profile: {
      handler() {
        if (this.profile) {
          this.checkApproved();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.requestNotificationPermission();
  }
};
</script>

<style scoped>
.chat-app-container {
  height: 100vh;
  padding: 0 !important;
  margin: 0 !important;
  max-width: 100% !important;
  overflow: hidden;
  background: #f0f2f5;
}

.chat-layout {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.chat-main-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background: #e5ddd5;
  position: relative;
}

.mobile-chat-container {
  height: 100vh;
  padding: 0 !important;
  margin: 0 !important;
  max-width: 100% !important;
  overflow: hidden;
  background: #e5ddd5;
}

/* Dark mode support */
.theme--dark .chat-app-container {
  background: #111b21;
}

.theme--dark .chat-main-area {
  background: #0b141a;
}
</style>